"use client";

import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";

import { Button } from "@/components/ui/button";

export function ThemeToggle() {
  const t = useTranslations();
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  const isDark = mounted && resolvedTheme === "dark";

  return (
    <Button
      variant="outline"
      size="icon"
      className="rounded-xl bg-background/70"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={isDark ? t("common.switchToLightMode") : t("common.switchToDarkMode")}
      title={isDark ? t("common.switchToLightMode") : t("common.switchToDarkMode")}
      type="button"
    >
      {isDark ? <Sun className="size-5" /> : <Moon className="size-5" />}
    </Button>
  );
}
